<template>
  <div
    class="flex h-fit w-fit justify-between gap-2 items-center rounded-full py-1.5 px-4 text-xs bg-primary-50 text-neutral-600 disabled:text-neutral-300 disabled:cursor-default"
    :class="{
      'cursor-pointer': closable,
      'font-bold': bold
    }"
    :disabled="disabled"
    @click="onClick"
  >
    <span v-if="label" class="text-neutral-700 disabled:text-neutral-400 font-semibold">
      {{ label }}: <span class="font-light"><slot/></span>
    </span>
    <span v-if="closable">
       <font-awesome-icon class="font-bold text-neutral-900 disabled:text-neutral-600" :icon="['fas', 'xmark']"/>
    </span>
  </div>
</template>

<script lang="ts" setup>

const emit = defineEmits(['close']);

interface Props {
  label?: string;
  bold?: boolean;
  closable?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  closable: false,
  disabled: false
});

function onClick() {
  if (props.closable) {
    emit('close');
  }
}
</script>
